function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}

export const initializeViewport = () => {
  const minWidth = 430;
  const fixed = `width=${minWidth}`;
  const fluid = "width=device-width,initial-scale=1";
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  const handleResize = () => {
    const vw = window.innerWidth;
    const current = viewport.getAttribute("content");
    const isFixed = current === fixed;

    if (!isFixed && vw <= minWidth) {
      viewport.setAttribute("content", fixed);
    } else if (isFixed && vw > minWidth + 1) {
      viewport.setAttribute("content", fluid);
    }
  };

  const debouncedResize = debounce(handleResize, 250);

  window.addEventListener("resize", debouncedResize);
  handleResize();
};
